export default __webpack_public_path__ + "static/media/bg-polistar.f3ab3bd0.png";